import { FC } from 'react';
import ClassCalendar from './Calendar';
import ClassCalendarDetail2 from './CalendarDetail2';
import ClassRollbook from './Rollbook';

interface IProps {
  tab: string;
  setTab: (tab: string) => void;
  setIsExtended: (isExtended: boolean) => void;
  getTimetables: (classCode: string) => void;
}

const ClassSchedule: FC<IProps> = ({
  tab,
  setTab,
  setIsExtended,
  getTimetables,
}) => {
  const renderTabContent = () => {
    switch (tab) {
      // 시간표 달력 표시
      case 'schedule':
        return <ClassCalendar setTab={setTab} setIsExtended={setIsExtended} />;
      // 수업일자/시간 수정
      case 'calendarDetail':
        return (
          <ClassCalendarDetail2 setTab={setTab} getTimetables={getTimetables} />
        );
      // 학급 출결 수정
      case 'rollbook':
        return <ClassRollbook setTab={setTab} />;
    }
  };

  return <>{renderTabContent()}</>;
};

export default ClassSchedule;
